import { render, staticRenderFns } from "./OtpHeader.vue?vue&type=template&id=4d47657b&scoped=true&"
import script from "./OtpHeader.vue?vue&type=script&lang=js&"
export * from "./OtpHeader.vue?vue&type=script&lang=js&"
import style0 from "./OtpHeader.vue?vue&type=style&index=0&id=4d47657b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47657b",
  null
  
)

export default component.exports